<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'drug_type:create' }"
        :deleteButton="{ permission: 'drug_type:delete' }"
        :updateButton="{ permission: 'drug_type:update' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DrugType`,
    props: {

    },
    data() {
        return {
            title: `基础数据-药品类型`,
            url: { baseURL: `/api/AcisSystem/DrugType` },
            buttons: []
        }
    },
    created() {
        this.$store.dispatch(`ADD_SYS_DOCUMENT_LIST`)
    },
    computed: {
        ...mapGetters([`sys_document_list`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                // width: "180",
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                // sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: true,
                sortable: true
            }, {
                type: `bool`,
                prop: `is_prescription`,
                label: `是否处方单药品`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: `enum_bool`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                default: false
            }, {
                type: `select`,
                prop: `prescription_doc_key`,
                label: `处方单模板`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                options: this.sys_document_list
            }, {
                type: `string`,
                prop: `prescription_no_generator_proc`,
                label: `处方单号生成存储过程`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }]
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/DrugType.vue